const mainPageSeoConfig = {
  learn: {
    about: "",
    videos:
      "Unlock the world of programming with our comprehensive video tutorials! From Python to Java, dive into coding fundamentals and advanced techniques. Start your journey to becoming a coding whiz today.",
    contact: "",
    terms: "",
    policy: "",
  },
  dishes: {
    about: "",
    videos: "",
    contact: "",
    terms: "",
    policy: "",
  },
};

export default mainPageSeoConfig;
